import { c as _c } from "react/compiler-runtime";
import { Package } from "@phosphor-icons/react/dist/ssr";
import { Link } from "@/i18n/navigation";
import ProductCard, { type ProductForCard } from "./ProductCard";
export default function ProductGrid(t0) {
  const $ = _c(15);
  const {
    products,
    locale
  } = t0;
  if (products.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Package size={48} weight="thin" className="mb-4" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    const t2 = locale === "ar" ? "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0646\u062A\u062C\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u062D\u0627\u0644\u064A\u0627\u064B" : "No products in this section yet";
    let t3;
    if ($[1] !== t2) {
      t3 = <p className="text-sm font-medium mb-1">{t2}</p>;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    const t4 = locale === "ar" ? "\u0627\u0644\u0639\u0648\u062F\u0629 \u0644\u0644\u0631\u0626\u064A\u0633\u064A\u0629" : "Back to Home";
    let t5;
    if ($[3] !== t4) {
      t5 = <Link href="/" className="text-sm text-primary hover:underline mt-2">{t4}</Link>;
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
      t6 = <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">{t1}{t3}{t5}</div>;
      $[5] = t3;
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  let t1;
  if ($[8] !== locale || $[9] !== products) {
    let t2;
    if ($[11] !== locale) {
      t2 = (product, i) => <ProductCard key={product.id} product={product} locale={locale} priority={i < 4} />;
      $[11] = locale;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t1 = products.map(t2);
    $[8] = locale;
    $[9] = products;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[13] !== t1) {
    t2 = <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">{t1}</div>;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}